/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Monday, September 26th 2022, 9:10:32 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import { FieldDependencyAction } from "lib/schemas";
import Badge from "@mui/material/Badge";
import Chip, { ChipProps } from "@mui/material/Chip";
import SettingsIcon from "@mui/icons-material/Settings";

type PermittedValuesChipButtonProps = Pick<FieldDependencyAction, "action_permitted_values"> &
  Pick<ChipProps, "onClick" | "color" | "variant">;

export const PermittedValuesChipButton = ({
  action_permitted_values,
  onClick,
  color,
  variant,
}: PermittedValuesChipButtonProps) =>
  action_permitted_values?.length ? (
    <Badge
      badgeContent={`${action_permitted_values.length} ${action_permitted_values.length > 1 ? "values" : "value"}`}
      color="primary"
    >
      <Chip onClick={onClick} color={color} variant={variant} icon={<SettingsIcon />} label={`Permitted Values`} />
    </Badge>
  ) : (
    <Chip onClick={onClick} color={color} variant={variant} icon={<SettingsIcon />} label="No Permitted Values Set" />
  );
